<div class="SLV2-books-popup-area">
    <div class="SLV2-books-popup-hdr-area">
        <div class="SLV2-books-popup-hdr-wrap">
            <h5 class="SLV2-books-popup-hdr-title">Books</h5>
            <h6 class="SLV2-books-popup-hdr-subtitle">Choose the book you want to start with</h6>
        </div>
        <button class="SLV2-popup-close-btn" (click)="close()">
            <img src="selflearnv2-ui/assets/img/self-learn-v2/close-black-icon.svg" />
        </button>
    </div>
    <div class="SLV2-books-popup-content-area">
        <ul class="SLV2-books-list">
            <li *ngFor="let book of data.books">
                <div class="SLV2-books-box" (click)="onBookSelect(book)">
                    <div class="SLV2-book-thumb">
                        <!-- <img src="selflearnv2-ui/assets/img/self-learn-v2/books-learn-logo.svg" class="SLV2-book-thumb-logo" /> -->
                        <img src="selflearnv2-ui/assets/img/self-learn-v2/books-thumb-icon.svg" class="SLV2-book-icon" />
                    </div>
                    <div class="SLV2-book-cntarea">
                        <h5 class="SLV2-book-title">{{book.name}}</h5>
                        <!-- <div class="SLV2-book-progress-area">
                            <div class="SLV2-book-progress"><span style="width:30%"></span></div>
                            <span class="prgtext">30%</span>
                        </div> -->
                    </div>
                </div>
            </li>
        </ul>
    </div>

</div>